import React from 'react';
import { motion } from 'framer-motion';

/**
 * GlassCard - reusable glasmorph container with subtle motion
 * Props:
 * - className: extra classes
 * - size: 'md' | 'lg'
 */
export function GlassCard({ children, className = '', size = 'md', style = {}, ...props }) {
  const variants = {
    hidden: { opacity: 0, y: 8, scale: 0.995 },
    enter: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.45, ease: 'easeOut' } }
  };
  return (
    <motion.div
      initial="hidden"
      animate="enter"
      variants={variants}
      className={`glass-card ${size === 'lg' ?'glass-card-lg' : ''} ${className}`}
      style={style}
      {...props}
    >
      {children}
    </motion.div>
  );
}

export default GlassCard;
